// Core
import React from "react";

// Styles
import "./styles.scss";

// Assets
import assets from "../../Assets"

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const getPageNumbers = () => {
    let pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      const leftBound = Math.max(1, currentPage - 2);
      const rightBound = Math.min(totalPages, currentPage + 2);

      if (leftBound > 1) {
        pages.push(1);
        if (leftBound > 2) pages.push("...");
      }

      for (let i = leftBound; i <= rightBound; i++) {
        pages.push(i);
      }

      if (rightBound < totalPages) {
        if (rightBound < totalPages - 1) pages.push("...");
        pages.push(totalPages);
      }
    }
    return pages;
  };

  const pageNumbers = getPageNumbers();

  return (
    <div className="pagination">
      <div
        className={`pagination-arrow ${currentPage === 1 ? "disabled" : ""}`}
        onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
      >
        <img style={{height:"15px"}} src={assets.Icons.leftArrow} alt="Previous" />
        Previous
      </div>
      {pageNumbers.map((page, index) => (
        <React.Fragment key={index}>
          {page === "..." ? (
            <span className="pagination-dots">...</span>
          ) : (
            <span
              className={`pagination-page ${
                currentPage === page ? "selected" : ""
              }`}
              onClick={() => onPageChange(page)}
            >
              {page}
            </span>
          )}
        </React.Fragment>
      ))}
      <div
        className={`pagination-arrow ${
          currentPage === totalPages ? "disabled" : ""
        }`}
        onClick={() =>
          currentPage < totalPages && onPageChange(currentPage + 1)
        }
      >
        Next
        <img src={assets.Icons.rightArrow} alt="Next" />
      </div>
    </div>
  );
};

export default Pagination;
